export type CreateDeploymentRequestInterfacePartnerNamesRequest = {
  dfnSetVerNum: string;
  forceStgDplyFlg: boolean;
  partnerIdList: PartnerInfo[];
};
export type PartnerInfo = {
  partnerCode: string;
  partnerType: string;
  partnerBuCd: string;
  dipByRgn: string;
};
